import React, { useEffect, useState } from "react";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import {
  OragnizationAll,
  OragnizationAllData,
  OragnizationDelete,
  OragnizationUpdate,
} from "../../redux/auth-reducer/auth-service";
import DataTable from "react-data-table-component";
import { Col, Row } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { GetToken } from "../../utils/helper/helper";
import Button from "react-bootstrap/Button";
import { ModalBox } from "../Outer/Modal";
import { Footer } from "../../Footer";
import dayjs from "dayjs";
import * as icons from "react-bootstrap-icons";

export const ViewOrganization = () => {
  const [sidebar, setSidebar] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const pageOptions = [10, 20, 30, 50];
  const [item, setItem] = useState({
    managerID: "",
    firstName: "",
    lastName: "",
    managerName: "",
    orgEmailId: "",
    crudOperationId: false,
  });
  const [show, setShow] = useState(false);

  function sidebarfun() {
    setSidebar(!sidebar);
  }
  const { managerID, firstName, lastName, orgEmailId, managerName } = item;
  // useEffect(() => {
  //     dataApi()
  // }, [count]);

  // const dataApi = async (event) => {
  //     await OragnizationAll().then((res) => {
  //         setApiData(res?.data?.data?.dataList)

  //     })
  // }

  const dataApi = async (data) => {
    try {
      const response = await OragnizationAllData(data); // Call your API function
      if (response?.data) {
        setApiData(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    dataApi(data); // Fetch data when currentPage changes
  }, [currentPage, count]); // Dependency on currentPage

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    dataApi(data);
    // Get the new value
    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };
  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  function convertUTCToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toString(); // Or use date.toLocaleString() for better format
  }

  const columns = [
    {
      name: <strong>Manager Name</strong>,
      selector: (row) => row?.firstName + " " + row?.lastName,
      sortable: true,
    },
    {
      name: <strong>Manager Email</strong>,
      selector: (row) => <>{row?.emailId}</>,
      sortable: true,
    },
    {
      name: <strong>Phone Number</strong>,
      selector: (row) => row?.phoneNumber,
      sortable: true,
    },

    {
      name: <strong>Organization Name</strong>,
      selector: (row) => (
        <>
          {row?.orgName == null ? (
            <span className="ms-5">-</span>
          ) : (
            row?.orgName
          )}
        </>
      ),
      sortable: true,
    },
    {
      name: <strong>Oragnization Email</strong>,
      selector: (row) => (
        <>
          {row?.orgEmailId == null ? (
            <span className="ms-5">-</span>
          ) : (
            row?.orgEmailId
          )}
        </>
      ),
      sortable: true,
    },

    {
      name: <strong>Join Date & Time</strong>,
      selector: (row) => {
        if (!row?.createdDate) return <p>Invalid date</p>;

        return (
          <p>{dayjs(row?.createdDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },

      sortable: true,
    },
  ];
  const token = GetToken();

  const editFn = async (manager) => {
    setItem(manager);
    setShow(true);
  };

  const viewFn = (manager) => {
    setItem(manager);
    setShowModal(true);
  };

  const deleteFn = async (orgId, e) => {
    await OragnizationDelete(orgId, token).then((res) => {
      if (res?.data?.status) {
        toast.success("Delete Successfully");
      } else {
        toast.error(res?.message);
      }
    });
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const filteredData = searchText
    ? apiData.filter((item) => {
        return item?.firstName
          ?.toLowerCase()
          .includes(searchText?.toLowerCase());
      })
    : apiData;

  const handelform = (e) => {
    setItem({
      ...item,
      [e.target.name]: e.target.value,
    });
  };
  const updateFn = async () => {
    await OragnizationUpdate(item, token).then((res) => {
      if (res?.status) {
        setCount(count + 1);
        handleClose();
        toast.success(res?.message);
      } else {
        toast.error(res?.message);
      }
    });
  };

  const handleClose = () => setShow(false);
  const handleClosed = () => {
    setShowModal(false);
    setShow(false);
  };

  const clearSearch = () => {
    setSearchText("");
  };

  return (
    <>
      <ModalBox
        show={show}
        onHide={handleClosed}
        title="Edit List"
        body={
          <>
            <input
              type="hidden"
              className="form-control"
              name="managerID"
              onChange={handelform}
              value={managerID}
            ></input>
            <br />
            <input
              type="text"
              className="form-control"
              name="firstName"
              onChange={handelform}
              value={firstName}
            ></input>
            <br />
            <input
              type="text"
              className="form-control"
              name="lastName"
              onChange={handelform}
              value={lastName}
            ></input>
            <br />
            <input
              type="text"
              className="form-control"
              name="managerName"
              onChange={handelform}
              value={managerName}
            ></input>
            <br />
            <input
              type="text"
              className="form-control"
              name="orgEmailId"
              onChange={handelform}
              value={orgEmailId}
            ></input>
            <br />
            <Row>
              <Col md="12" className="text-right">
                <Button variant="primary" onClick={updateFn}>
                  Update
                </Button>
              </Col>
            </Row>
          </>
        }
      />

      <ModalBox
        show={showModal}
        onHide={handleClosed}
        title="View List"
        body={
          <>
            <input
              type="text"
              className="form-control"
              value={firstName}
            ></input>
            <br />
            <input
              type="text"
              className="form-control"
              value={lastName}
            ></input>
            <br />
            <input
              type="text"
              className="form-control"
              value={managerName}
            ></input>
            <br />
            <input
              type="text"
              className="form-control"
              value={orgEmailId}
            ></input>
            <br />
          </>
        }
      />

      <TopNavbar sidebarfun={sidebarfun} />

      <div className="dasboard-group">
        <Sidebar data={sidebar} />
        <div
          className={
            sidebar ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row>
            <Col md="10">
              <h1 className="heading-dash">Managers List</h1>
            </Col>
            <Col md="2 text-right mb-3"></Col>
          </Row>

          <div className="table-responsive">
            <div className="group_data_table View-organization">
              <div className="search-input d-flex align-items-center">
                <input
                  type="text"
                  className="form-control mb-3 mt-3"
                  placeholder="Search..."
                  value={searchText}
                  onChange={handleSearch}
                />
                {searchText && (
                  <button className="btn btn-clear" onClick={clearSearch}>
                    <span>&times;</span> {/* This represents the close icon */}
                  </button>
                )}
              </div>
              {/* <DataTable
                                title="Player List"
                                columns={columns}
                                data={filteredData}
                                pagination
                                paginationPerPage={10}
                                paginationRowsPerPageOptions={[5, 10, 15]}
                                paginationTotalRows={filteredData?.length}
                            /> */}
              <div>
                <DataTable
                  title="Sport List"
                  columns={columns}
                  data={filteredData}
                  paginationPerPage={perPage}
                  paginationTotalRows={totalRows * 10}
                  paginationDefaultPage={currentPage}
                  onChangePage={setCurrentPage}
                />
                {totalRows >= 1 && (
                  <Row>
                    <Col md={12} className="text-right">
                      <div className="pagination-controls">
                        <>
                          <label>Rows page: </label>{" "}
                          <select
                            id="itemsPerPage"
                            value={perPage}
                            onChange={handlePerPageChange}
                          >
                            {pageOptions.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </>

                        <Button
                          onClick={handlePreviousPage}
                          disabled={currentPage === 1}
                        >
                          <icons.ArrowLeft></icons.ArrowLeft>
                        </Button>
                        <span>
                          {currentPage} of {totalRows}{" "}
                        </span>
                        <Button
                          onClick={handleNextPage}
                          disabled={currentPage >= Math.ceil(totalRows)}
                        >
                          <icons.ArrowRight></icons.ArrowRight>
                        </Button>
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={sidebar ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
